export const calculateSizeAndPositionOnParent = ([
  {
    parentSize,
    elementXPositionPercentage,
    elementYPositionPercentage,
    elementWidthPercentage,
    elementHeightPercentage,
  },
]) => {
  const { width: parentWidth, height: parentHeight } = parentSize;
  const calculateElementLeftPositionOnParent = parseInt(
    (parentWidth / 100) * elementXPositionPercentage,
    10,
  );
  const calculateElementTopPositionOnParent = parseInt(
    (parentHeight / 100) * elementYPositionPercentage,
    10,
  );
  const calculateElementWidth = parseInt(
    (parentWidth / 100) * elementWidthPercentage,
    10,
  );
  const calculateElementHeight = parseInt(
    (parentHeight / 100) * elementHeightPercentage,
    10,
  );

  return {
    position: 'absolute',
    left: calculateElementLeftPositionOnParent,
    top: calculateElementTopPositionOnParent,
    width: calculateElementWidth,
    height: calculateElementHeight,
  };
};

export const canvasPositionsAndSizes = (parentSize, name, canvasNumber) => {
  const layoutsSizesByName = {
    twelve: [
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 30,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 60,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 90,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 120,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 150,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 180,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 210,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 240,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 270,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 300,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 330,
          elementWidthPercentage: 100,
          elementHeightPercentage: 30,
        },
      ],
    ],
    twelvePlusOne: [
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 25,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 50,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 75,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 25,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 25,
          elementYPositionPercentage: 25,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 50,
          elementYPositionPercentage: 25,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 75,
          elementYPositionPercentage: 25,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 50,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 25,
          elementYPositionPercentage: 50,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 50,
          elementYPositionPercentage: 50,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 75,
          elementYPositionPercentage: 50,
          elementWidthPercentage: 25,
          elementHeightPercentage: 25,
        },
      ],
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 75,
          elementWidthPercentage: 100,
          elementHeightPercentage: 25,
        },
      ],
    ],
    one: [
      [
        {
          parentSize,
          elementXPositionPercentage: 0,
          elementYPositionPercentage: 0,
          elementWidthPercentage: 100,
          elementHeightPercentage: 100,
        },
      ],
    ],
  };

  return layoutsSizesByName[name][canvasNumber];
};

// mejor llamar a esto en este caso : SupportInstances.isWaveform;
export const isECG = (modality) => modality === 'ECG';
